import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { IMAGES, scrollToBuy } from '../utils/constants';
const HIGHLIGHTS = ['1 Main Box Set', '5 Strategic Bonuses', '6 Complete Modules', 'Special Education Teachers', 'Individual, Small-Group & Classroom Support'];
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-108" data-mp="4n9zemrrxo5a">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-3 pb-5 pt-5 text-center sm:px-5 sm:pt-7" data-id="element-109" data-mp="129h21r4ip6f0">
        <span className="font-head text-[10px] uppercase tracking-[0.14em] text-steel sm:text-xs" data-id="element-110" data-mp="xanq434vpngy">
          The #1 Ready-To-Use System For Special Education Teachers
        </span>

        <h1 className="mt-1.5 font-head text-[30px] uppercase leading-[0.95] text-ink sm:text-5xl lg:text-6xl" data-id="element-111" data-mp="nc88qrvnlskn">
          Have your next adapted lesson ready{' '}
          <span className="italic text-mustard" data-id="element-112" data-mp="3d33fj0i70xlt">in minutes.</span>
        </h1>

        <p className="mt-2 max-w-2xl text-[13px] leading-snug text-muted sm:text-base" data-id="element-113" data-mp="381e0l9runzsg">
          Your complete 6-in-1 professional special education teaching system: visual supports,
          adaptable activities, differentiation tools, classroom routines, planning resources,
          progress tracking, and ready-to-use materials.
        </p>

        <button type="button" onClick={scrollToBuy} className="mt-2 block w-full max-w-2xl transition-opacity duration-150 ease-out hover:opacity-95" aria-label="Go to the purchase section" data-id="element-114" data-mp="39cpain8uf6z7">
          <img src={IMAGES.boxSet} alt="Special Education Teacher Pro complete box set with six modules and five bonuses" className="mx-auto w-full" loading="eager" data-id="element-115" data-mp="30fybq32wpe0x" />
        </button>

        <ul className="-mt-1 flex flex-wrap justify-center gap-x-2 gap-y-1 text-[10px] font-bold uppercase tracking-wide text-ink sm:text-xs" data-id="element-116" data-mp="2qloeo830rrjv">
          {HIGHLIGHTS.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-117" data-mp="2hkgj3xrw14th" data-mpi={index}>
              {index > 0 && <span className="text-sage" aria-hidden="true" data-id="element-118" data-mp="2ll0dwuoznwcg">·</span>}
              {item}
            </li>)}
        </ul>

        <div className="mt-3 flex w-full flex-col items-center" data-id="element-119" data-mp="s2tffr2zujsd">
          <CtaButton data-id="element-120" data-mp="nat7pcgomml8" />
          <TrustRow className="mt-2" data-id="element-121" data-mp="na9zingu3cke" />
        </div>
      </div>
    </header>;
}